import React from 'react';
import { bool, string, oneOf } from 'prop-types';
import { Card, CardContent, CircularProgress, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import SadFaceIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const LoadingSplashScreen = ({ show, showProgress, content, icon }) => {

  if (show) {
    return (
      <Card>
        <CardContent className={`text-center`}>
          {icon === 'warning' && <WarningIcon style={{fontSize: '4em'}} />}
          {icon === 'sad' && <SadFaceIcon style={{fontSize: '4em'}} />}
          {showProgress && <CircularProgress />}
          <Typography variant="h4">{content}</Typography>
        </CardContent>
      </Card>
    );
  }

  return null;
};

LoadingSplashScreen.propTypes = {
  show: bool,
  showProgress: bool,
  content: string.isRequired,
  icon: oneOf(['sad', 'warning'])
};

LoadingSplashScreen.defaultProps = {
  show: false,
  showProgress: true
};

export default LoadingSplashScreen;
